module.exports = __webpack_public_path__ + "img/renxiang.8c989fed.png";